import { render, staticRenderFns } from "./SalesDetail.vue?vue&type=template&id=4343f874"
import script from "./SalesDetail.vue?vue&type=script&lang=js"
export * from "./SalesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports